import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { isSentryEnabled } from './sentry.config';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    console.error(error);

    if (isSentryEnabled) {
      Sentry.captureException(error);
    }
  }
}
